export type InputPrefixProps = {
	prefixText: string;
};

const InputPrefix = ({ prefixText }: InputPrefixProps) => {
	return <span className="text-font-greyDisabled">{prefixText}</span>;
};

export default InputPrefix;
